import { FitmentSearchParams } from '@api-client/src/api/types';
import { useSearchFactory } from '@vue-storefront/core';
import { mapToFitmentSearchResponse } from '../helpers/mapToFitmentSearchResponse';
import { FitmentSearchOptions, IFitmentResult, ISearchResponse } from '../types';

const useFitmentSearch = useSearchFactory<ISearchResponse<IFitmentResult[]>, FitmentSearchOptions>({
  search: async (context, options) => {
    const indexName = 'fitments';
    const { resultsPerPage, facets, filters } = options;
    const params: FitmentSearchParams = { hitsPerPage: 1 };

    params.hitsPerPage = resultsPerPage;
    params.facets = facets;
    params.filters = filters;

    try {
      const fitmentSearchResult = await context.$search.api.fitmentSearch([
        {
          indexName,
          ...params,
        },
      ]);

      return mapToFitmentSearchResponse(fitmentSearchResult);
    } catch (e) {
      console.error(e);

      return null;
    }

    const searchResponse = await context.$search.api.search(params);

    return searchResponse;
  },
});

export default useFitmentSearch;
